import styled from 'styled-components'

export const StyledOption = styled.li`
   list-style-type:none;
   text-transform:uppercase;
   font-weight:bold;
   color:#9f9f9f;
   margin-left:10px;
`

export const OptionText = styled.h2`
    width:200px;
    font-size:14px;
    display:inline-block;
`
export const OptionInput = styled.input`
    width:100px;
    font-size:14px;
   color:#9f9f9f;
    background:#272727;
    border:1px solid #808080;
    display:inline-block;
    padding:5px;
`

export const OptionSelect = styled.select`
    min-width:100px;
    font-size:14px;
    color:#9f9f9f;
    background:#272727;
    border:1px solid #808080;
    display:inline-block;
    padding:5px;
`